import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  FaChevronRight, 
  FaMapMarkerAlt, 
  FaMobileAlt, 
  FaClock, 
  FaEnvelope 
} from 'react-icons/fa';
import { FaTractor } from 'react-icons/fa';
import '../../../../assets/css/user/general/footer/Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  const informationLinks = [
    { id: 1, text: 'Main Home', url: '/' },
    { id: 2, text: 'Equipments', url: '/Equipments' },
    { id: 3, text: 'Shop', url: '/Shop' },
    { id: 4, text: 'Mechanics', url: '/Mechanics' },
    { id: 5, text: 'Aboutus', url: '/Aboutus' },
    { id: 6, text: 'Blogs', url: '/Blog' },
    { id: 7, text: 'Contact', url: '/Contact' }
  ];

  const recentPosts = [ 
    { id: 1, title: 'Top Equipment for Modern Farming', date: '28/08/2025' },
    { id: 2, title: 'How to Choose the Right Tractor', date: '30/09/2025' },
    { id: 3, title: 'Importance of Regular Machine Maintenance', date: '28/12/2025' }
  ];

  return (
    <footer className="footer-section">
      <Container>
        <Row className="footer-content">

          {/* About Company Column */}
          <Col lg={3} md={6} sm={12} className="footer-col mb-4">
            <h3 className="footer-heading">About Company</h3>
            
            <div className="company-logo-footer">

              {/* ✅ Same circle+tractor logo — sidebar & navbar style */}
              <div className="tractor-logo-circle">
                <FaTractor size={32} />
              </div>
              
              <div className="brand-text-footer">
                <div className="brand-name-footer">SMART AGRI RENT</div>
                <div className="brand-subtitle-footer">EQUIPMENT RENTAL & MAINTENANCE</div>
              </div>
            </div>

            <p className="company-description">
              SmartAgri Rent is an agriculture equipment rental and maintenance platform designed to support farmers with easy access to modern machinery. We provide reliable rental services and professional maintenance support to ensure smooth and efficient farming operations.
            </p>
          </Col>

          {/* Information Column */}
          <Col lg={3} md={6} sm={12} className="footer-col mb-4">
            <h3 className="footer-heading">Information</h3>
            <ul className="footer-links">
              {informationLinks.map((link) => (
                <li key={link.id} className="footer-link-item">
                  <Link to={link.url} className="footer-link">
                    <FaChevronRight className="link-arrow" />
                    <span className="link-text">{link.text}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Contact Info Column */}
          <Col lg={3} md={6} sm={12} className="footer-col mb-4">
            <h3 className="footer-heading">Contact Info</h3>
            <div className="contact-info-list">
              <div className="foot-contact-item">
                <FaMapMarkerAlt className="contact-icon1" />
                <p className="contact-text">
                  <strong>Address:</strong> Gujranwala, Punjab, Pakistan
                </p>
              </div>
              <div className="foot-contact-item">
                <FaMobileAlt className="contact-icon1" />
                <p className="contact-text">
                  <strong>Custom Support & Sale:</strong> +1-5050-607080
                </p>
              </div>
              <div className="foot-contact-item">
                <FaClock className="contact-icon1" />
                <p className="contact-text">
                  <strong>Working Time:</strong> Mon-Sat: 9 AM – 5 PM
                </p>
              </div>
              <div className="foot-contact-item">
                <FaEnvelope className="contact-icon1" />
                <p className="contact-text">
                  <strong>Email:</strong><br />
                  <a href="mailto:smartagrirent111@gmail.com" className="email-link">
                    smartagrirent111@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </Col>

          {/* Recent Post Column */}
          <Col lg={3} md={6} sm={12} className="footer-col mb-4">
            <h3 className="footer-heading">Recent Post</h3>
            <ul className="recent-posts-list">
              {recentPosts.map((post) => (
                <li key={post.id} className="recent-post-item">
                  <a href="#" className="post-link">
                    <h4 className="post-title">{post.title}</h4>
                    <p className="post-date">{post.date}</p>
                  </a>
                </li>
              ))}
            </ul>
          </Col>
        </Row>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="copyright-text">© 2025 SmartAgriRent. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;